import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=d4871b36&scoped=true&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"
import style0 from "./Index.vue?vue&type=style&index=0&id=d4871b36&prod&scoped=true&lang=scss&"
import style1 from "./Index.vue?vue&type=style&index=1&id=d4871b36&prod&lang=scss&"
import style2 from "./Index.vue?vue&type=style&index=2&id=d4871b36&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4871b36",
  null
  
)

export default component.exports